<div class="card">
    <div class="card-body">
        <div class="d-flex align-items-center mb-3">
            <button type="button" class="bill-service__back-icon me-2" (click)="goBack()" aria-label="Regresar">
                <i class="ti ti-arrow-left"></i>
            </button>
            <h4 class="mb-0">{{ refacturaMode ? 'Refacturar Servicio' : 'Facturar Servicio' }}<span *ngIf="folio"> - Folio {{ folio }}</span></h4>
            <button type="button" class="btn btn-info btn-service btn-add ms-auto" style="background-color: #00A0E1; border-color: #00A0E1;" (click)="onPreview()">
                <i class="ti ti-eye"></i>
                Vista Previa
            </button>
        </div>

        <!-- Referencia al CFDI que se está sustituyendo -->
        <div class="bill-service__refactura-banner" *ngIf="refacturaMode">
            <i class="ti ti-file-invoice"></i>
            <div>
                <div class="bill-service__refactura-title">
                    Sustituye a la factura
                    <span class="bill-service__code-chip">{{ originalInvoiceFolio }}</span>
                </div>
                <div class="bill-service__refactura-meta" *ngIf="originalInvoiceUuid">UUID {{ originalInvoiceUuid }}</div>
                <div class="bill-service__refactura-meta">
                    Corrige lo necesario y genera el CFDI sustituto; la original queda vigente hasta timbrar.
                </div>
            </div>
        </div>

        <div class="bill-service__refactura-warning" *ngIf="refacturaMode && refacturaApproximate">
            <i class="ti ti-alert-triangle"></i>
            No se pudo leer el XML del CFDI original: los conceptos son una aproximación a partir del total. Revísalos antes de timbrar.
        </div>

        <div class="text-muted mb-3" *ngIf="loadingDraft">Cargando datos de la factura original…</div>

        <div class="bill-service__step d-flex align-items-center">
            <span class="bill-service__step-circle">0</span>
            <span class="bill-service__step-label">Entidad que factura</span>
        </div>

        <div class="bill-service__fiscal-card mt-3">
            <div class="row g-3 align-items-end">
                <div class="col-md-8">
                    <label class="bill-service__field-label">Empresa que factura</label>
                    <div class="bill-service__custom-select" [class.is-open]="billingEntityOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="toggleBillingEntity()">
                            <span class="bill-service__custom-select-value" *ngIf="selectedBillingEntity; else placeholderBillingEntityTpl">
                                <span class="bill-service__code-chip">{{ selectedBillingEntity.rfc }}</span>
                                <span>{{ selectedBillingEntity.name }}</span>
                            </span>
                            <ng-template #placeholderBillingEntityTpl>
                                <span class="bill-service__custom-select-placeholder">Selecciona una entidad</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="billingEntityOpen">
                            <li *ngFor="let entity of billingEntities" class="bill-service__custom-select-option" (click)="selectBillingEntity(entity.id)">
                                <span class="bill-service__code-chip">{{ entity.rfc }}</span>
                                <span>{{ entity.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-4">
                    <button type="button" class="btn btn-info btn-service btn-add w-100" style="background-color: #00A0E1; border-color: #00A0E1;" (click)="onAddBillingEntity()">
                        <i class="ti ti-plus"></i>
                        Agregar nueva entidad de factura
                    </button>
                </div>
            </div>
        </div>

        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">1</span>
            <span class="bill-service__step-label">Datos fiscales del cliente</span>
            <span class="bill-service__client-chip" *ngIf="clientName">{{ clientName }}</span>
        </div>

        <div class="bill-service__fiscal-card mt-3">
            <div class="row g-3">
                <div class="col-md-4 col-sm-6">
                    <div class="bill-service__field-label">RFC</div>
                    <div class="bill-service__field-value">{{ rfc || '—' }}</div>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="bill-service__field-label">Razón social</div>
                    <div class="bill-service__field-value">{{ razonSocial || '—' }}</div>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="bill-service__field-label">Régimen fiscal</div>
                    <div class="bill-service__field-value">
                        <span class="bill-service__code-chip" *ngIf="regimenFiscalKey">{{ regimenFiscalKey }}</span>
                        <span *ngIf="regimenFiscalDesc">{{ regimenFiscalDesc }}</span>
                        <span *ngIf="!regimenFiscalKey && !regimenFiscalDesc">—</span>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="bill-service__field-label">Código postal</div>
                    <div class="bill-service__field-value">{{ codigoPostal || '—' }}</div>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="bill-service__field-label">Domicilio fiscal</div>
                    <div class="bill-service__field-value">{{ domicilioFiscal || '—' }}</div>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="bill-service__field-label">Correo electrónico (opcional)</div>
                    <div class="bill-service__field-value">{{ email || '—' }}</div>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="bill-service__field-label">Uso de CFDI</div>
                    <div class="bill-service__field-value">
                        <span class="bill-service__code-chip" *ngIf="usoCfdiKey">{{ usoCfdiKey }}</span>
                        <span *ngIf="usoCfdiDesc">{{ usoCfdiDesc }}</span>
                        <span *ngIf="!usoCfdiKey && !usoCfdiDesc">—</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">2</span>
            <span class="bill-service__step-label">Configuración de CFDI</span>
        </div>

        <div class="bill-service__fiscal-card mt-3">
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="bill-service__field-label">Forma de Pago</label>
                    <div class="bill-service__custom-select" [class.is-open]="paymentFormOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="togglePaymentForm()">
                            <span class="bill-service__custom-select-value" *ngIf="selectedPaymentForm; else placeholderTpl">
                                <span class="bill-service__code-chip">{{ selectedPaymentForm.key }}</span>
                                <span>{{ selectedPaymentForm.name }}</span>
                            </span>
                            <ng-template #placeholderTpl>
                                <span class="bill-service__custom-select-placeholder">Selecciona una forma de pago</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="paymentFormOpen">
                            <li *ngFor="let pf of paymentForms" class="bill-service__custom-select-option" (click)="selectPaymentForm(pf.key)">
                                <span class="bill-service__code-chip">{{ pf.key }}</span>
                                <span>{{ pf.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="bill-service__field-label">Método de Pago</label>
                    <div class="bill-service__custom-select" [class.is-open]="paymentMethodOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="togglePaymentMethod()">
                            <span class="bill-service__custom-select-value" *ngIf="selectedPaymentMethod; else placeholderMethodTpl">
                                <span class="bill-service__code-chip">{{ selectedPaymentMethod.key }}</span>
                                <span>{{ selectedPaymentMethod.name }}</span>
                            </span>
                            <ng-template #placeholderMethodTpl>
                                <span class="bill-service__custom-select-placeholder">Selecciona un método de pago</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="paymentMethodOpen">
                            <li *ngFor="let pm of paymentMethods" class="bill-service__custom-select-option" (click)="selectPaymentMethod(pm.key)">
                                <span class="bill-service__code-chip">{{ pm.key }}</span>
                                <span>{{ pm.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">3</span>
            <span class="bill-service__step-label">Concepto a facturar</span>
        </div>

        <div class="bill-service__fiscal-card mt-3">
            <label for="service-description" class="bill-service__field-label">Descripción del servicio</label>
            <div class="bill-service__textarea-wrapper">
                <textarea
                    id="service-description"
                    class="form-control bill-service__textarea"
                    placeholder="Ingresar"
                    rows="4"
                    [maxlength]="serviceDescriptionMax"
                    [(ngModel)]="serviceDescription"></textarea>
                <span class="bill-service__textarea-counter">{{ serviceDescription.length }}/{{ serviceDescriptionMax }}</span>
            </div>

            <div class="row g-3 mt-2">
                <div class="col-md-4">
                    <label for="quantity" class="bill-service__field-label">Cantidad</label>
                    <input
                        id="quantity"
                        type="number"
                        min="0"
                        step="1"
                        class="form-control"
                        placeholder="Ingresar"
                        [(ngModel)]="quantity">
                </div>
                <div class="col-md-4">
                    <label class="bill-service__field-label">Unidad</label>
                    <div class="bill-service__custom-select" [class.is-open]="unitOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="toggleUnit()">
                            <span class="bill-service__custom-select-value" *ngIf="selectedUnit; else placeholderUnitTpl">
                                <span class="bill-service__code-chip">{{ selectedUnit.key }}</span>
                                <span>{{ selectedUnit.name }}</span>
                            </span>
                            <ng-template #placeholderUnitTpl>
                                <span class="bill-service__custom-select-placeholder">Selecciona una unidad</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="unitOpen">
                            <li *ngFor="let u of units" class="bill-service__custom-select-option" (click)="selectUnit(u.key)">
                                <span class="bill-service__code-chip">{{ u.key }}</span>
                                <span>{{ u.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-4">
                    <label for="unit-price" class="bill-service__field-label">Precio Unitario</label>
                    <input
                        id="unit-price"
                        type="number"
                        min="0"
                        step="0.01"
                        class="form-control"
                        placeholder="$0.00"
                        [(ngModel)]="unitPrice">
                </div>
            </div>

            <div class="row g-3 mt-2">
                <div class="col-12">
                    <label class="bill-service__field-label">Clave de servicio/producto (SAT)</label>
                    <div class="bill-service__custom-select" [class.is-open]="productServiceOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="toggleProductService()">
                            <span class="bill-service__custom-select-value" *ngIf="selectedProductService; else placeholderProdSrvTpl">
                                <span class="bill-service__code-chip">{{ selectedProductService.key }}</span>
                                <span>{{ selectedProductService.name }}</span>
                            </span>
                            <ng-template #placeholderProdSrvTpl>
                                <span class="bill-service__custom-select-placeholder">Selecciona una clave</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="productServiceOpen">
                            <li *ngFor="let p of productServiceKeys" class="bill-service__custom-select-option" (click)="selectProductService(p.key)">
                                <span class="bill-service__code-chip">{{ p.key }}</span>
                                <span>{{ p.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="row g-3 mt-2">
                <div class="col-md-4">
                    <label class="bill-service__field-label">¿El servicio es objeto de impuesto?</label>
                    <div class="bill-service__custom-select" [class.is-open]="taxObjectOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="toggleTaxObject()">
                            <span class="bill-service__custom-select-value" *ngIf="selectedTaxObject; else placeholderTaxObjTpl">
                                <span class="bill-service__code-chip">{{ selectedTaxObject.key }}</span>
                                <span>{{ selectedTaxObject.name }}</span>
                            </span>
                            <ng-template #placeholderTaxObjTpl>
                                <span class="bill-service__custom-select-placeholder">Selecciona una opción</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="taxObjectOpen">
                            <li *ngFor="let t of taxObjectOptions" class="bill-service__custom-select-option" (click)="selectTaxObject(t.key)">
                                <span class="bill-service__code-chip">{{ t.key }}</span>
                                <span>{{ t.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">4</span>
            <span class="bill-service__step-label">Comprobante de pago (Opcional)</span>
        </div>

        <div class="bill-service__upload-area mt-3">
            <input #fileInput type="file" accept="image/png,application/pdf" multiple class="d-none" (change)="onFilesSelected($event)">

            <div class="row g-3">
                <div class="col-md-6">
                    <a *ngIf="uploadedFiles.length === 0" href="javascript:void(0)" class="bill-service__upload-link" (click)="fileInput.click()">
                        Subir comprobante
                    </a>

                    <div *ngIf="uploadedFiles.length > 0" class="bill-service__upload-files">
                        <div *ngFor="let f of uploadedFiles; let i = index" class="bill-service__upload-item">
                            <img *ngIf="f.type === 'png' && f.previewUrl" [src]="f.previewUrl" alt="" class="bill-service__upload-thumb">
                            <div *ngIf="f.type === 'pdf'" class="bill-service__upload-pdf">
                                <i class="ti ti-file-type-pdf"></i>
                            </div>
                            <span class="bill-service__upload-name">{{ f.file.name }}</span>
                            <button type="button" class="bill-service__upload-remove" (click)="removeFile(i)" aria-label="Quitar">
                                <i class="ti ti-x"></i>
                            </button>
                        </div>

                        <a href="javascript:void(0)" class="bill-service__upload-link mt-2" (click)="fileInput.click()">
                            Subir más comprobantes
                        </a>
                    </div>
                </div>

                <div class="col-md-6" *ngIf="clientId">
                    <label class="bill-service__field-label">¿Consolidar otros servicios en esta factura?</label>
                    <div class="bill-service__custom-select" [class.is-open]="multiInvoiceOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="toggleMultiInvoice()">
                            <span class="bill-service__custom-select-value" *ngIf="selectedMultiInvoice; else placeholderMultiTpl">
                                <span>{{ selectedMultiInvoice }}</span>
                            </span>
                            <ng-template #placeholderMultiTpl>
                                <span class="bill-service__custom-select-placeholder">Selecciona una opción</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="multiInvoiceOpen">
                            <li *ngFor="let opt of multiInvoiceOptions" class="bill-service__custom-select-option" (click)="selectMultiInvoice(opt)">
                                <span>{{ opt }}</span>
                            </li>
                        </ul>
                    </div>

                    <div *ngIf="selectedMultiInvoice === 'Sí, asociar'" class="mt-3">
                        <label class="bill-service__field-label">Servicios disponibles para consolidar</label>
                        <div class="bill-service__custom-select" [class.is-open]="invoiceOpen">
                            <button type="button" class="bill-service__custom-select-trigger" (click)="toggleInvoice()">
                                <span class="bill-service__custom-select-value" *ngIf="associatedInvoices.length > 0; else placeholderInvoiceTpl">
                                    <span>{{ associatedInvoices.length }} servicio{{ associatedInvoices.length === 1 ? '' : 's' }} seleccionado{{ associatedInvoices.length === 1 ? '' : 's' }}</span>
                                </span>
                                <ng-template #placeholderInvoiceTpl>
                                    <span class="bill-service__custom-select-placeholder">Selecciona servicios</span>
                                </ng-template>
                                <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                            </button>
                            <div class="bill-service__custom-select-menu bill-service__invoice-menu" *ngIf="invoiceOpen" (click)="$event.stopPropagation()">
                                <div class="bill-service__invoice-search">
                                    <i class="ti ti-search bill-service__invoice-search-icon"></i>
                                    <input
                                        type="text"
                                        class="bill-service__invoice-search-input"
                                        [(ngModel)]="invoiceSearchText"
                                        placeholder="Buscar por folio, origen, destino..."
                                        autocomplete="off">
                                    <button type="button"
                                            class="bill-service__invoice-search-clear"
                                            *ngIf="invoiceSearchText"
                                            (click)="invoiceSearchText = ''"
                                            aria-label="Limpiar búsqueda">
                                        <i class="ti ti-x"></i>
                                    </button>
                                </div>
                                <div class="bill-service__invoice-list">
                                    <div *ngIf="filteredAvailableInvoices.length === 0" class="bill-service__custom-select-option text-muted">
                                        Sin servicios disponibles
                                    </div>
                                    <label *ngFor="let inv of filteredAvailableInvoices"
                                           class="bill-service__invoice-option"
                                           [class.is-selected]="isInvoiceAssociated(inv.id)">
                                        <input type="checkbox"
                                               class="bill-service__invoice-checkbox"
                                               [checked]="isInvoiceAssociated(inv.id)"
                                               (change)="toggleInvoiceSelection(inv)">
                                        <span class="bill-service__code-chip">{{ inv.folio || inv.id }}</span>
                                        <span class="bill-service__invoice-option-text">{{ inv.origin_address || '—' }} → {{ inv.destination_address || '—' }}</span>
                                    </label>
                                </div>
                                <div class="bill-service__invoice-confirm">
                                    <button type="button"
                                            class="bill-service__invoice-confirm-btn"
                                            (click)="toggleInvoice()"
                                            [disabled]="associatedInvoices.length === 0">
                                        <i class="ti ti-check"></i>
                                        Listo
                                        <span *ngIf="associatedInvoices.length > 0">
                                            ({{ associatedInvoices.length }} seleccionado{{ associatedInvoices.length === 1 ? '' : 's' }})
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="associatedInvoices.length > 0 && !invoiceOpen" class="bill-service__associated-panel mt-3">
                            <div class="bill-service__associated-header">
                                <div class="bill-service__associated-title">
                                    <i class="ti ti-receipt"></i>
                                    Servicios a consolidar
                                </div>
                                <span class="bill-service__associated-count">{{ associatedInvoices.length }}</span>
                            </div>
                            <div class="bill-service__associated-list">
                                <div *ngFor="let inv of associatedInvoices" class="bill-service__associated-item">
                                    <span class="bill-service__code-chip">{{ inv.folio || inv.id }}</span>
                                    <span class="flex-grow-1">{{ inv.origin_address || '—' }} → {{ inv.destination_address || '—' }}</span>
                                    <!-- En refacturación cada concepto conserva y edita su propia
                                         descripción; en el alta normal todos comparten la del paso 3. -->
                                    <input *ngIf="refacturaMode" type="text" maxlength="900"
                                           class="form-control form-control-sm bill-service__associated-desc"
                                           [(ngModel)]="inv.service_description"
                                           placeholder="Descripción del concepto">
                                    <div class="bill-service__summary-input-wrapper">
                                        <span class="bill-service__summary-input-prefix">$</span>
                                        <input type="number" min="0" step="0.01"
                                               class="bill-service__summary-input"
                                               placeholder="0.00"
                                               [(ngModel)]="inv.unit_price">
                                    </div>
                                    <button type="button" class="bill-service__upload-remove" (click)="removeAssociatedInvoice(inv.id)" aria-label="Quitar">
                                        <i class="ti ti-x"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="associatedInvoices.length > 0 && !invoiceOpen" class="bill-service__summary-panel mt-3">
                            <div class="bill-service__summary-row">
                                <span class="bill-service__summary-label">Total a facturar (subtotal, sin IVA)</span>
                                <span class="bill-service__summary-multiplier">x{{ totalSelectedCount }}</span>
                                <span class="bill-service__summary-total">${{ totalSelectedAmount | number:'1.2-2' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bill-service__actions d-flex justify-content-center gap-3 mt-5">
            <button type="button" class="btn bill-service__btn-cancel" (click)="onCancel()" [disabled]="isGenerating">Cancelar</button>
            <button type="button" class="btn bill-service__btn-submit" (click)="onGenerateInvoice()" [disabled]="!isFormValid || isGenerating">
                <span *ngIf="!isGenerating">{{ refacturaMode ? 'Generar refacturación' : 'Generar factura' }}</span>
                <span *ngIf="isGenerating"><i class="ti ti-loader bill-service__spin"></i> Generando…</span>
            </button>
        </div>
    </div>
</div>

<ngx-spinner name="refactura" bdColor="rgba(255, 255, 255, 0.88)" size="large"
             color="#00A0E1" type="ball-clip-rotate" [fullScreen]="true">
    <p class="bill-service__spinner-text">Timbrando factura...</p>
</ngx-spinner>
